var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryNotReportingNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.791 1.52h2.535v-.318A.213.213 0 0 0 6.11 1h-2.1a.213.213 0 0 0-.218.202v.319zm9.883 0h2.535v-.318A.213.213 0 0 0 15.99 1h-2.1a.213.213 0 0 0-.217.202v.319zM1.971 3.594C1.435 3.593 1 4 1 4.496v9.601c0 .494.435.903.97.903h16.06c.535 0 .97-.409.97-.903V4.496c0-.494-.435-.903-.97-.903H1.97z",
    stroke: "#6D7278",
    strokeWidth: 1.814,
    fill: "#6D7278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.557 8.75v1.196H3.721V8.749h4.836zm5.435-1.82v1.818l1.82.001v1.197h-1.82v1.821h-1.197V9.945l-1.82.001V8.749h1.82V6.93h1.197z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryNotReportingNew);
export default __webpack_public_path__ + "static/media/battery_not_reporting_new.8bb1b21edce25acb276df08cc5622858.svg";
export { ForwardRef as ReactComponent };